'use client';

import SmallArrow from '@/assets/svg/SmallArrow';
import { Direction } from '@/types/direction';
import { cn } from '@/lib/utils';
import Link from 'next/link';

interface SectionProps {
  data: Direction[];
}

export default function ServicesSection(props: SectionProps) {
  const { data } = props;

  return (
    <div className='py-20 sm:py-5 md:py-10'>
      <ul>
        {data.map((section, index: number) => (
          <div
            className={cn(
              'grid grid-cols-4  lg:grid-cols-5 sm:flex lg:gap-8 sm:flex-col md:flex md:flex-col md:gap-6 sm:gap-6 sm:px-2 lg:px-4 md:px-4 px-24 gap-12 border-[#F2F2F280] border-t py-6 min-h-52 2xl:pl-[160px] 2xl:pr-[160px] pl-[90px] pr-[90px] ',
              {
                'border-b': index === data.length - 1,
              }
            )}
            key={section.color}
          >
            <div className='flex gap-4 lg:col-span-2'>
              <div
                className='2xl:w-6 2xl:h-6 w-4 h-4 sm:w-3 sm:h-3 mt-0.5 rounded-full shrink-0'
                style={{
                  backgroundColor: section.color,
                }}
              />
              <div className='2xl:text-[30px] text-[20px] 2xl:w-[240px] w-[170px]  break-words sm:text-[16.88px] text-white leading-none tracking-normal uppercase font-boldz\'>
                {section.name}
              </div>
            </div>
            <div className='sm:pl-7 flex flex-col gap-2'>
              {section.services.map((i) => {
                return (
                  <Link href={`/services/${i.slug}`}>
                    <p
                      key={i.name}
                      className='2xl:text-[18px] 2xl:w-[365px] w-[250px] text-[13px] text-[#F2F2F2] leading-[120%] tracking-[-0.03em] uppercase sm:text-[14.27px] font-normal'
                    >
                      {i.name.toUpperCase()}
                      <span className='inline-block ml-2 2xl:w-3 2xl:h-3 w-2 h-2 sm:h-[9px] sm:w-[10px]'>
                        <SmallArrow />
                      </span>
                    </p>
                  </Link>
                );
              })}

              {/* if it's ophir industrial */}
              {section.name.toLowerCase() === 'ophir industrial' && (
                <Link href={`/services/vr-training-and-simulation`}>
                  <p
                    key="VR Training and Simulation"
                    className='2xl:text-[18px] 2xl:w-[365px] w-[250px] text-[13px] text-[#F2F2F2] leading-[120%] tracking-[-0.03em] uppercase sm:text-[14.27px] font-normal'
                  >
                    VR Training and Simulation
                    <span className='inline-block ml-2 2xl:w-3 2xl:h-3 w-2 h-2 sm:h-[9px] sm:w-[10px]'>
                      <SmallArrow />
                    </span>
                  </p>
                </Link>
              )}
            </div>
            <div className='col-span-2 sm:pl-7'>
              <p className='sm:text-[13px] 2xl:text-[16px] text-[13px] text-white leading-[131%] font-normal font-poppins'>
                {section.description}
              </p>
            </div>
          </div>
        ))}
      </ul>
    </div>
  );
}
